import { render, staticRenderFns } from "./UpdateMainEvent.vue?vue&type=template&id=5e56dca2&scoped=true&"
import script from "./UpdateMainEvent.vue?vue&type=script&lang=js&"
export * from "./UpdateMainEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56dca2",
  null
  
)

export default component.exports